import React, { useState, useEffect } from 'react';
import nxtds_icons from '../../dashIcon';
import { Link, useLocation, useNavigate } from 'react-router-dom';
var plugin_url = nxtext_ajax_object.nxtex_url;
import { nxtdash_save_data, extraOptionsSave } from '../../apicall';
import Components from '../components/components';
const { Nexter_Tabs, Nexter_Tab, Nexter_Label_Heading, Nexter_RadioAdvanced, Nexter_Text, Nexter_Typography, Nexter_Color, Nexter_Dimension } = Components;
import Nexter_Icons from '../components/icons'
import ProNotice from '../pro-model/pro-notice'
import LoginAttemptTable from './login_view_log';
import ExtensionInstallPopup from '../extension_install_pop/ext_install_pop'

import './security.scss';
import { __ } from '@wordpress/i18n';

let extensionInstall = (nxtext_ajax_object?.dashData?.extensioninstall) ? true : false;

var SecurityData = [
    {
        key: 'advance-security',
        name: __('Advanced Security', 'nexter-extension'),
        tooltip: __('A set of options to improve your site’s security.', 'nexter-extension'),
        popDesc: __('A set of options to improve your site’s security.', 'nexter-extension'),
        formField: { key: 'advance-security', label: __('Enter API Key', 'nexter-extension') },
        doclink: 'https://nexterwp.com/help/nexter-extension/advanced-security/'
    },
    {
        key: 'captcha-security',
        name: __('CAPTCHA', 'nexter-extension'),
        tooltip: __('Add reCAPTCHA protection to your site.', 'nexter-extension'),
        popDesc: __('Increase spam protection by adding reCAPTCHA protection at various locations on your site.', 'nexter-extension'),
        formField: { key: 'captcha-security', label: __('Enter API Key', 'nexter-extension') },
        doclink: 'https://nexterwp.com/help/nexter-extension/setup-captcha-in-wordpress/',
        isBeta : false,
    },
    {
        key: 'custom-login',
        name: __('Custom Login URL', 'nexter-extension'),
        tooltip: __('Add custom WP-Admin login URL.', 'nexter-extension'),
        popDesc: __('Secure your site by hiding the WP-Admin login URL and creating a custom login URL to block spammers.', 'nexter-extension'),
        formField: { key: 'custom-login', label: __('Enter API Key', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/change-wordpress-admin-login-url-path/'
    },
    {
        key: 'svg-upload',
        name: __('SVG Upload', 'nexter-extension'),
        tooltip: __('Allow users to upload SVG files.', 'nexter-extension'),
        popDesc: __('Allow selected or all user roles to upload SVG files, which will be sanitized for security.', 'nexter-extension'),
        formField: { key: 'svg-upload', label: __('SVG Upload', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/enable-svg-upload-in-wordpress/',
    }
];

var adv_security_data_toggle = [
    {
        name: __('Disable XML-RPC', 'nexter-extension'),
        id: 'disable_xml_rpc',
        tooltip: __('Disable XML-RPC to reduce brute force attacks.', 'nexter-extension')
    },
    {
        name: __('Hide WordPress Version', 'nexter-extension'),
        id: 'disable_wp_version',
        tooltip: __('Hide the WordPress version from the public to increase security.', 'nexter-extension')
    },
    {
        name: __('Remove REST API Links', 'nexter-extension'),
        id: 'disable_rest_api_links',
        tooltip: __('Remove REST API links from the code, if not used.', 'nexter-extension')
    },
    {
        name: __('Disable File Editor', 'nexter-extension'),
        id: 'disable_file_editor',
        tooltip: __('Disable the WordPress file editor to increase security.', 'nexter-extension')
    },
    {
        name: __('Remove Meta Generator', 'nexter-extension'),
        id: 'remove_meta_generator',
        tooltip: __('Remove the meta generator code to hide the WordPress and plugin versions from the public.', 'nexter-extension')
    },
    {
        name: __('XSS Protection', 'nexter-extension'),
        id: 'xss_protection',
        tooltip: __('Enable XSS protection to increase security.', 'nexter-extension')
    }
];

var adv_security_data_toggle2 = [
    {
        name: __('Secure Cookies', 'nexter-extension'),
        id: 'secure_cookies',
        tooltip: __('Enable secure cookies to ensure encrypted and secure data transfer.', 'nexter-extension')
    },{
        name: __('Last Login Date & Time', 'nexter-extension'),
        id: 'user_last_login_display',
        tooltip: __('Track user\'s last login date and time and display it in the users list table.', 'nexter-extension')
    },{
        name: __('Registration Date & Time', 'nexter-extension'),
        id: 'user_register_date_time',
        tooltip: __('Track user\'s registration date and time in the users list table.', 'nexter-extension')
    },{
        name: __('Hide Email from Spam Bots', 'nexter-extension'),
        id: 'obfuscator_email_address',
        tooltip: __('Display email like [obfuscate email="john@site.com" display="inline"] so bots can\'t scrape it.', 'nexter-extension'),
        isPro : true,
    },{
        name: __('Hide Telephone Secure Spam Bots', 'nexter-extension'),
        id: 'hide_telephone_secure',
        tooltip: __('Protects contact info from bots — use [nxt_encode link="tel:+1555123"]+1 (555) 123-4567[/nxt_encode] to display a safe, clickable number.', 'nexter-extension'),
        isPro : true,
        isNew : true,
    },{
        name: __('Hide Author URLs for Security', 'nexter-extension'),
        id: 'obfuscator_author_slug',
        tooltip: __('Changes links like /author/admin/ to a scrambled version and returns a 404 if someone tries to guess the original.', 'nexter-extension'),
        isPro : true,
    }
];
var adv_security_data_select = [
    {
        name: __('REST API', 'nexter-extension'),
        id: 'disable_rest_api',
        tooltip: __('Disable REST API for logged-out and non-admin users.', 'nexter-extension'),
        options: {
            '': __('Enabled', 'nexter-extension'),
            'non_admin': __('Disable for Non-Admin', 'nexter-extension'),
            'logged_out': __('Disable When Logged Out', 'nexter-extension'),
        }
    },
    {
        name: __('iFrame Security', 'nexter-extension'),
        id: 'iframe_security',
        tooltip: __('Disable iFrame embedding to prevent your site from being embedded on other websites.', 'nexter-extension'),
        options: {
            'disabled': __('Disabled', 'nexter-extension'),
            'sameorigin': __('Same Origin', 'nexter-extension'),
            'deny': __('Deny', 'nexter-extension'),
        }
    },
];

var login_behaviour = {
    "message": __("Message (Default)", 'nexter-extension'),
    "home_page": __("Home Page", 'nexter-extension'),
    "404_page": __("404 Page Template", 'nexter-extension')
};

var all_users_list = nxtext_ajax_object?.dashData?.roles || []

// Check if WooCommerce is installed
var woocommerce_exists = nxtext_ajax_object?.dashData?.woocommerce || false;

var content_protection_list = {
    "disable-r-click": __("Disable Right Click", 'nexter-extension'),
    "disable-drag": __("Disable Drag/Drop", 'nexter-extension'),
    "disable-dev-key": __("Disable Dev's Tools Hot Keys", 'nexter-extension'),
    "disable-ser-key": __("Disable Search Hot Keys", 'nexter-extension'),
    "disable-ctrlc-key": __("Disable Ctrl+C/CMD+C", 'nexter-extension'),
    "disable-ctrlv-key": __("Disable Ctrl+V/CMD+V", 'nexter-extension'),
    "disable-ctrla-key": __("Disable Ctrl+A/CMD+A", 'nexter-extension'),
    "disable-ctrlu-key": __("Disable Ctrl+U/CMD+U", 'nexter-extension'),
    "disable-ctrlp-key": __("Disable Ctrl+P/CMD+P", 'nexter-extension'),
    "disable-ctrlh-key": __("Disable Ctrl+H/CMD+H", 'nexter-extension'),
    "disable-ctrll-key": __("Disable Ctrl+L/CMD+L", 'nexter-extension'),
    "disable-ctrlk-key": __("Disable Ctrl+K", 'nexter-extension'),
    "disable-ctrlo-key": __("Disable Ctrl+O", 'nexter-extension'),
    "disable-ctrle-key": __("Disable Ctrl+E", 'nexter-extension'),
    "disable-altd-key": __("Disable Alt+D", 'nexter-extension'),
    "disable-f3-key": __("Disable F3", 'nexter-extension'),
    "disable-f6-key": __("Disable F6", 'nexter-extension'),
    "disable-f12-key": __("Disable F12", 'nexter-extension'),
    "disable-text-selection": __("Disable Text Selection", 'nexter-extension')
};

var ai_crawler_user_agents = [
    'AddSearchBot',
    'AI2Bot',
    'Ai2Bot-Dolma',
    'aiHitBot',
    'AmazonBot',
    'Applebot-Extended',
    'anthropic-ai',
    'bedrockbot',
    'bigsur.ai',
    'Brightbot 1.0',
    'Bytespider',
    'CCBot',
    'ChatGPT-User',
    'ClaudeBot',
    'Claude-User',
    'Claude-SearchBot',
    'cohere-ai',
    'cohere-training-data-crawler',
    'Cotoyogi',
    'Crawlspace',
    'DeepSeekBot',
    'Diffbot',
    'EchoboxBot',
    'FacebookBot',
    'Factset_spyderbot',
    'FirecrawlAgent',
    'FriendlyCrawler',
    'GPTBot',
    'GoogleAgent-Mariner',
    'Gemini-Deep-Research',
    'Google-Extended',
    'ImagesiftBot',
    'Kangaroo Bot',
    'meta-externalagent',
    'Meta-externalfetcher',
    'OAI-SearchBot',
    'Omgili',
    'Omgilibot',
    'PanguBot',
    'Panscient',
    'Panscient.com',
    'PetalBot',
    'PerplexityBot',
    'Perplexity‑User',
    'Poseidon Research Crawler',
    'SBIntuitionsBot',
    'Scrapy',
    'SemrushBot',
    'SemrushBot-OCOB',
    'SemrushBot-FT',
    'SentiBot',
    'sentibot',
    'TerraCotta',
    'Thinkbot',
    'Timpibot',
    'TurnitinBot',
    'Yak',
    'YandexAdditional',
    'YandexAdditionalBot',
    'YouBot',
    'webzio',
    'webzio-extended'
];

const captcha_options = [
    {
        title: __('WordPress Default', 'nexter-extension'),
        name: 'formType',
        checkboxes: [
            [
                { id: 'login_form', label: __('Login Form', 'nexter-extension'), disabled: false },
                { id: 'registration_form', label: __('Registration Form', 'nexter-extension'), disabled: false },
            ],
            [
                { id: 'reset_pwd_form', label: __('Reset Password Form', 'nexter-extension'), disabled: false },
                { id: 'comments_form', label: __('Comments Form', 'nexter-extension'), disabled: false },
            ],
        ],
    },
    {
        title: __('WooCommerce', 'nexter-extension'),
        name: 'nexter_recaptcha_woo',
        tooltip: __('Add reCAPTCHA security to various locations of WooCommerce.', 'nexter-extension'),
        checkboxes: [
            [
                { id: 'woo_checkout', label: __('Checkout', 'nexter-extension'), disabled: !woocommerce_exists },
                { id: 'woo_pay_for_order', label: __('Pay For Order', 'nexter-extension'), disabled: !woocommerce_exists },
            ],
            [
                { id: 'woo_login_form', label: __('Login Form', 'nexter-extension'), disabled: !woocommerce_exists },
                { id: 'woo_registration_form', label: __('Registration Form', 'nexter-extension'), disabled: !woocommerce_exists },
            ],
            [
                { id: 'woo_reset_pwd_form', label: __('Reset Password Form', 'nexter-extension'), disabled: !woocommerce_exists },
            ],
        ],
    },
    {
        title: __('Forms Support', 'nexter-extension'),
        name: 'nexter_recaptcha_3rd',
        tooltip: __('Add reCAPTCHA security on different 3rd-party forms.', 'nexter-extension'),
        checkboxes: [
            [
               /*  { id: 'nexter_block_form', label: __('Nexter Block Form', 'nexter-extension'), disabled: false }, */
                { id: '3d_elementor_form', label: __('Elementor Form', 'nexter-extension'), disabled: true, locked: true },
                { id: '3d_ninja_form', label: __('Ninja Form', 'nexter-extension'), disabled: true, locked: true },
            ],
            [
                { id: '3d_wp_form', label: __('WPForm', 'nexter-extension'), disabled: true, locked: true },
                { id: '3d_cf7_form', label: __('Contact Form 7', 'nexter-extension'), disabled: true, locked: true },
            ],
            [
                { id: '3d_everest_form', label: __('Everest Form', 'nexter-extension'), disabled: true, locked: true },
                { id: '3d_gravity_form', label: __('Gravity Form', 'nexter-extension'), disabled: true, locked: true },
            ],
        ],
    },
];

const lockedSVG = () =>{
    return (
        <svg className="nxt-locked-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><rect width="17" height="17" rx="3.4" fill="#666666"/><path d="M11.1029 7.01172V5.78825C11.1019 5.12676 10.8387 4.49265 10.3709 4.02491C9.9032 3.55716 9.26909 3.29395 8.6076 3.29297H8.39191C7.73042 3.29395 7.09631 3.55716 6.62857 4.02491C6.16083 4.49265 5.89761 5.12676 5.89663 5.78825V7.01172C5.60075 7.01172 5.31699 7.12926 5.10776 7.33848C4.89854 7.5477 4.78101 7.83146 4.78101 8.12734V11.5858C4.78199 12.1477 5.00563 12.6862 5.40293 13.0835C5.80024 13.4808 6.33882 13.7045 6.90069 13.7055H10.0988C10.6607 13.7045 11.1993 13.4808 11.5966 13.0835C11.9939 12.6862 12.2175 12.1477 12.2185 11.5858V8.12734C12.2185 7.83146 12.101 7.5477 11.8917 7.33848C11.6825 7.12926 11.3988 7.01172 11.1029 7.01172ZM6.64038 5.78825C6.64038 5.32371 6.82492 4.87821 7.15339 4.54973C7.48187 4.22125 7.92738 4.03672 8.39191 4.03672H8.6076C9.07213 4.03672 9.51764 4.22125 9.84612 4.54973C10.1746 4.87821 10.3591 5.32371 10.3591 5.78825V7.01172H6.64038V5.78825ZM11.4748 11.5858C11.4748 11.9507 11.3298 12.3007 11.0718 12.5587C10.8137 12.8168 10.4637 12.9617 10.0988 12.9617H6.90069C6.53577 12.9617 6.1858 12.8168 5.92776 12.5587C5.66972 12.3007 5.52476 11.9507 5.52476 11.5858V8.12734C5.52476 8.02872 5.56394 7.93413 5.63368 7.86439C5.70342 7.79465 5.798 7.75547 5.89663 7.75547H11.1029C11.2015 7.75547 11.2961 7.79465 11.3658 7.86439C11.4356 7.93413 11.4748 8.02872 11.4748 8.12734V11.5858Z" fill="white"/><path d="M8.87173 10.2541V11.4738C8.87173 11.5724 8.83255 11.667 8.76281 11.7368C8.69307 11.8065 8.59848 11.8457 8.49985 11.8457C8.40123 11.8457 8.30664 11.8065 8.2369 11.7368C8.16716 11.667 8.12798 11.5724 8.12798 11.4738V10.2541C7.98619 10.1722 7.87537 10.0458 7.81272 9.89458C7.75006 9.74332 7.73907 9.57561 7.78145 9.41746C7.82382 9.25932 7.9172 9.11957 8.04709 9.0199C8.17698 8.92024 8.33613 8.86621 8.49985 8.86621C8.66358 8.86621 8.82273 8.92024 8.95262 9.0199C9.08251 9.11957 9.17589 9.25932 9.21826 9.41746C9.26064 9.57561 9.24964 9.74332 9.18699 9.89458C9.12433 10.0458 9.01352 10.1722 8.87173 10.2541Z" fill="white"/></svg>
    )
}


    // Concatenate with additional settings
    SecurityData = SecurityData.concat([
        {
            key: '2-fac-authentication',
            name: __('2-Factor Authentication', 'nexter-extension'),
            tooltip: __('Add 2-Factor Authentication to secure your WordPress login.', 'nexter-extension'),
            popDesc: __('Add 2-Factor Authentication by different user roles to secure your WordPress login.', 'nexter-extension'),
            formField: { key: '2-fac-authentication', label: __('Enter API Key', 'nexter-extension') },
            doclink: 'https://nexterwp.com/docs/add-two-factor-authentication-in-wordpress/',
            isPro : true
        },
        {
            key: 'wp-right-click-disable',
            name: __('Content Protection', 'nexter-extension'),
            tooltip: __('A set of options to protect your website content from plagiarism.', 'nexter-extension'),
            popDesc: __('A set of options to protect your website content from plagiarism and unauthorized copying.', 'nexter-extension'),
            formField: { key: 'wp-right-click-disable', label: __('Enter API Key', 'nexter-extension') },
            doclink: 'https://nexterwp.com/docs/content-protection-for-wordpress-overview/',
            isPro : true
        },
        {
            key: 'email-login-notification',
            name: __('Login Email Notification', 'nexter-extension'),
            tooltip: __('Get email alerts for WordPress admin logins to track access.', 'nexter-extension'),
            popDesc: __('Get email notifications when someone logs into your WordPress admin to track any unusual activity.', 'nexter-extension'),
            formField: { key: 'email-login-notification', label: __('Enter API Key', 'nexter-extension') },
            doclink: 'https://nexterwp.com/docs/send-login-email-notification-in-wordpress/',
            isPro : true
        },
        {
            key: 'limit-login-attempt',
            name: __('Limit Login Attempts', 'nexter-extension'),
            tooltip: __('Limit failed login attempts per IP address to help protect your site from brute force attacks.', 'nexter-extension'),
            popDesc: __('Limit failed login attempts per IP address to help protect your site from brute force attacks.', 'nexter-extension'),
            formField: { key: 'limit-login-attempt', label: __('Limit Login Attempts', 'nexter-extension') },
            doclink: 'https://nexterwp.com/docs/limit-login-attempts-in-wordpress/',
            isFreemium : true,
            isNew : true,
        },
        {
            key: 'block-ai-crawlers',
            name: __('Block AI Crawlers', 'nexter-extension'),
            tooltip: __('Block AI crawlers and bots via robots.txt and meta tags to prevent AI training on your content.', 'nexter-extension'),
            popDesc: __('Block AI crawlers and bots via robots.txt and meta tags. This plugin automatically blocks major AI crawlers like ChatGPT, Claude, Google Extended, and many others.', 'nexter-extension'),
            formField: { key: 'block-ai-crawlers', label: __('Block AI Crawlers', 'nexter-extension') },
            doclink: '#',
        }
    ]);

if (nxtext_ajax_object.pro) {
    const fontPro = SecurityData.find(setting => setting.key === 'fontawesome_load');
    if (fontPro) {
        fontPro.popDesc = __("Paste your Font Awesome PRO Kit ID below <a href = 'https://fontawesome.com/license' target='_blank' rel='noopener noreferrer'> Get ID </a>", 'nexter-extension');
        fontPro.formField = { 'fontawesome_pro_kit': __('FontAwesome Pro Kit', 'nexter-extension') };
        fontPro.docLink = '#';
    }
}



const Security = (props) => {
    const [enabledSettings, setEnabledSettings] = useState(() => {
        const securitySettings = window.securitySetData || nxtext_ajax_object?.dashData?.nxtSecurity || {};
       
        const securityOptKeys = ["iframe_security", "disable_rest_api"];
        const securityOptValues = [
        "obfuscator_email_address","disable_xml_rpc","disable_rest_api_links",
        "remove_meta_generator","secure_cookies","user_register_date_time",
        "obfuscator_author_slug","hide_telephone_secure","user_last_login_display",
        "xss_protection","disable_wp_version","disable_file_editor"
        ];

        // check keys
        const hasKeyMatch = securityOptKeys.some(key => key in securitySettings);

        // check values
        const hasValueMatch = securityOptValues.some(value =>
        Object.values(securitySettings).includes(value)
        );
        
        let cleanedSettings = {};
        if(hasValueMatch){
            const keysToRemove = ['2-fac-authentication', 'captcha-security', 'custom-login', 'key', 'label', 'email-login-notification', 'limit-login-attempt','svg-upload','wp-right-click-disable','advance-security','block-ai-crawlers'];
            cleanedSettings = Object.fromEntries(
                Object.entries(securitySettings).filter(([key]) => !keysToRemove.includes(key))
            );
        }
        
        const hasMatch = hasKeyMatch || hasValueMatch;
        // Initialize the settings object
        const defaultSettings = {
            'advance-security' : {
                switch: (securitySettings['advance-security'] && securitySettings['advance-security'].switch) ? securitySettings['advance-security'].switch : hasMatch ? true : false,
                values: cleanedSettings || {}
            },
            'email-login-notification': { 
                switch: (securitySettings['email-login-notification'] && securitySettings['email-login-notification'].switch) ? securitySettings['email-login-notification'].switch : false,
                values: {
                    'get_alert': [],
                    'exclude_ips': [],
                    'subject' : '',
                    'alert_message': 'Dear Admin,<br>We noticed a new login to your account: Username: [username] User Role: [RoleName] Date and Time: [Date] at [Time] IP Address: [IP Address]<br>If this was you, no further action is needed. If you do not recognize this login, please secure your account immediately by changing your password and reviewing your account activity. Stay safe, [WordPress Site Name]. This email was sent from Email Login Notification from Nexter Extension.'
                }
            },
            '2-fac-authentication': {
                switch: (securitySettings['2-fac-authentication'] && securitySettings['2-fac-authentication'].switch) ? securitySettings['2-fac-authentication'].switch : false,
                values: {
                    "allowed_2fa_roles": [],
                    "email_customisations": {
                        "subject": "",
                        "body": "Hello [username],<br>To complete your login, please enter the following Two-Factor Authentication code.<br>Code: [token]<br>This code is valid for the next 10 minutes. If this wasn't you, please change your password immediately or contact the site admin.<br>Best regards,<br>[SiteName]<br>Time Sent: [Time]<br>This email was sent from 2-Factor Authentication from Nexter Extension."
                    }
                }
            },
            'captcha-security' : {
                switch: (securitySettings['captcha-security'] && securitySettings['captcha-security'].switch) ? securitySettings['captcha-security'].switch : false,
                values: {
                    'captcha_type': 'google',
                    'siteKey': '',
                    'secretKey': '',
                    'turnSiteKey' : '',
                    'turnSecretKey' : '',
                    'formType': []
                }
            },
            'svg-upload': { 
                switch: (securitySettings['svg-upload'] && securitySettings['svg-upload'].switch) ? securitySettings['svg-upload'].switch : false,
                values: []
            },
            'limit-login-attempt': {
                switch: (securitySettings['limit-login-attempt'] && securitySettings['limit-login-attempt'].switch) ? securitySettings['limit-login-attempt'].switch : false,
                values: {
                    'failed_login': 5,
                    'lockout_login': 5,
                    'ip_address_list': '',
                    'header_override' : ''
                }
            },
            'custom-login':{
                switch: (securitySettings['custom-login'] && securitySettings['custom-login'].switch) ? securitySettings['custom-login'].switch : (securitySettings?.custom_login_url) ? true : false,
                values: {
                    'custom_login_url': securitySettings?.custom_login_url || '',
                    'disable_login_url_behavior': securitySettings?.disable_login_url_behavior || 'message',
                    'login_page_message': securitySettings?.login_page_message || 'Sorry the page you were looking for does not exist or is not available',
                }
            },
            'wp-right-click-disable': {
                switch: securitySettings['wp-right-click-disable']?.switch !== undefined
                    ? securitySettings['wp-right-click-disable']?.switch
                    : (securitySettings['wp-right-click-disable']?.values ?? false),
                values : securitySettings['wp-right-click-disable']?.values || {},
                css : securitySettings['wp-right-click-disable']?.css || '',
            },
            'block-ai-crawlers': {
                switch: (securitySettings['block-ai-crawlers'] && securitySettings['block-ai-crawlers'].switch) ? securitySettings['block-ai-crawlers'].switch : false,
                values: {
                    'custom_robots_txt': securitySettings['block-ai-crawlers']?.values?.custom_robots_txt || '',
                    'selected_user_agents': securitySettings['block-ai-crawlers']?.values?.selected_user_agents || []
                }
            }
        };

        if (!securitySettings['advance-security'] || !securitySettings['advance-security']['values'] || !securitySettings['advance-security']['switch']) {
            securitySettings['advance-security'] = defaultSettings['advance-security'];
        }

        // Check if keys are present and merge with defaults
        if (!securitySettings['email-login-notification'] || !securitySettings['email-login-notification']['values']) {
            securitySettings['email-login-notification'] = defaultSettings['email-login-notification'];
        }
    
        if (!securitySettings['2-fac-authentication'] || !securitySettings['2-fac-authentication']['values']) {
            securitySettings['2-fac-authentication'] = defaultSettings['2-fac-authentication'];
        }

        if (!securitySettings['captcha-security'] || !securitySettings['captcha-security']['values']) {
            securitySettings['captcha-security'] = defaultSettings['captcha-security'];
        }

        if (!securitySettings['svg-upload'] || !securitySettings['svg-upload']['values']) {
            securitySettings['svg-upload'] = defaultSettings['svg-upload'];
        }
        if (!securitySettings['limit-login-attempt'] || !securitySettings['limit-login-attempt']['values']) {
            securitySettings['limit-login-attempt'] = defaultSettings['limit-login-attempt'];
        }
        if (!securitySettings['custom-login'] || !securitySettings['custom-login']['values']) {
            securitySettings['custom-login'] = defaultSettings['custom-login'];
        }
        if (!securitySettings['wp-right-click-disable'] || !securitySettings['wp-right-click-disable']['values'] || !securitySettings['wp-right-click-disable']['switch']) {
            securitySettings['wp-right-click-disable'] = defaultSettings['wp-right-click-disable'];
        }
        if (!securitySettings['block-ai-crawlers'] || !securitySettings['block-ai-crawlers']['values']) {
            securitySettings['block-ai-crawlers'] = defaultSettings['block-ai-crawlers'];
        }
        return {
            ...securitySettings,
        };
    });
    
    const [emailIp, setEmailIp] = useState(
        enabledSettings &&
        enabledSettings['email-login-notification'] &&
        enabledSettings['email-login-notification'].values &&
        Array.isArray(enabledSettings['email-login-notification'].values['exclude_ips']) 
          ? enabledSettings['email-login-notification'].values['exclude_ips'].join(",") 
          : ''
    );


    const [loginData, setLoginData] = useState([]);
    const [processLoginData, setProcessLoginData] = useState(false);
    const [viewLoginData, setviewLoginData] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isPopupProVisible, setIsPopupProVisible] = useState(false);
    const [isPopupExtensionInstall, setIsPopupExtensionInstall] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupInputValue, setPopupInputValue] = useState({});
    const [selectedRestApi, setselectedRestApi] = useState(adv_security_data_select[0].options[enabledSettings['disable_rest_api']] || adv_security_data_select[0].options[enabledSettings['advance-security']?.values?.disable_rest_api]|| 'Enabled');
    const [selectedIframe, setselectedIframe] = useState(adv_security_data_select[1].options[enabledSettings['iframe_security']] || adv_security_data_select[1].options[enabledSettings['advance-security']?.values?.iframe_security] || 'Disabled');

    const [extType, setExtType] = useState('');

    const [device, setDevice] = useState(props.deviceType || 'md');

    const defaultTypo = {
        openTypography: 1,
        size: '',
        height: '',
        spacing: '',
        fontFamily: {},
    }
    const defaultDimension = {
        md: {top: '', bottom: '', left: '', right: ''},
        sm: {top: '', bottom: '', left: '', right: ''},
        xs: {top: '', bottom: '', left: '', right: ''},
        unit: 'px'
    }

    const [settings, setSettings] = useState({

        /* Single Value and Color */
        "disable-r-click": enabledSettings['wp-right-click-disable']?.values?.['disable-r-click'] || false,
        "disable-r-click-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-r-click-msg'] || 'This function is disabled',
        "disable-drag": enabledSettings['wp-right-click-disable']?.values?.['disable-drag'] || false,
        "disable-drag-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-drag-msg'] || 'This function is disabled',
        "disable-dev-key": enabledSettings['wp-right-click-disable']?.values?.['disable-dev-key'] || false,
        "disable-dev-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-dev-key-msg'] || 'This function is disabled',
        "disable-ser-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ser-key'] || false,
        "disable-ser-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ser-key-msg'] || 'This function is disabled',
        "disable-ctrlc-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlc-key'] || false,
        "disable-ctrlc-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlc-key-msg'] || 'This function is disabled',
        "disable-ctrlv-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlv-key'] || false,
        "disable-ctrlv-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlv-key-msg'] || 'This function is disabled',
        "disable-ctrla-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrla-key'] || false,
        "disable-ctrla-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrla-key-msg'] || 'This function is disabled',
        "disable-ctrlu-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlu-key'] || false,
        "disable-ctrlu-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlu-key-msg'] || 'This function is disabled',
        "disable-ctrlp-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlp-key'] || false,
        "disable-ctrlp-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlp-key-msg'] || 'This function is disabled',
        "disable-ctrlh-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlh-key'] || false,
        "disable-ctrlh-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlh-key-msg'] || 'This function is disabled',
        "disable-ctrll-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrll-key'] || false,
        "disable-ctrll-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrll-key-msg'] || 'This function is disabled',
        "disable-ctrlk-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlk-key'] || false,
        "disable-ctrlk-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlk-key-msg'] || 'This function is disabled',
        "disable-ctrlo-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlo-key'] || false,
        "disable-ctrlo-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrlo-key-msg'] || 'This function is disabled',
        "disable-ctrle-key": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrle-key'] || false,
        "disable-ctrle-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-ctrle-key-msg'] || 'This function is disabled',
        "disable-altd-key": enabledSettings['wp-right-click-disable']?.values?.['disable-altd-key'] || false,
        "disable-altd-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-altd-key-msg'] || 'This function is disabled',
        "disable-f3-key": enabledSettings['wp-right-click-disable']?.values?.['disable-f3-key'] || false,
        "disable-f3-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-f3-key-msg'] || 'This function is disabled',
        "disable-f6-key": enabledSettings['wp-right-click-disable']?.values?.['disable-f6-key'] || false,
        "disable-f6-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-f6-key-msg'] || 'This function is disabled',
        "disable-f12-key": enabledSettings['wp-right-click-disable']?.values?.['disable-f12-key'] || false,
        "disable-f12-key-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-f12-key-msg'] || 'This function is disabled',
        "disable-text-selection": enabledSettings['wp-right-click-disable']?.values?.['disable-text-selection'] || false,
        "disable-text-selection-msg": enabledSettings['wp-right-click-disable']?.values?.['disable-text-selection-msg'] || 'This function is disabled',
        "disable_access": enabledSettings['wp-right-click-disable']?.values?.['disable_access'] || [],
        "alert-pos": enabledSettings['wp-right-click-disable']?.values?.['alert-pos'] || 'top_right',
        'alert-dis-time': enabledSettings['wp-right-click-disable']?.values?.['alert-dis-time'] || '3000',

        'msg-bg-color': enabledSettings['wp-right-click-disable']?.values?.['msg-bg-color'] || '',
        'msg-border-color': enabledSettings['wp-right-click-disable']?.values?.['msg-border-color'] || '',
        'msg-title-color': enabledSettings['wp-right-click-disable']?.values?.['msg-title-color'] || '',
        'msg-desc-color': enabledSettings['wp-right-click-disable']?.values?.['msg-desc-color'] || '',
        'msg-icon-color': enabledSettings['wp-right-click-disable']?.values?.['msg-icon-color'] || '',
        'msg-icon-bg-progress': enabledSettings['wp-right-click-disable']?.values?.['msg-icon-bg-progress'] || '',
       
        /* Dimension */
        messPadding: enabledSettings['wp-right-click-disable']?.values?.messPadding || defaultDimension,

        /* Typography */
        titleTypo: enabledSettings['wp-right-click-disable']?.values?.titleTypo || defaultTypo,
        descTypo: enabledSettings['wp-right-click-disable']?.values?.descTypo || defaultTypo,
    })

    const handleCheckboxChange = (e, key, opt) => {
        const updateSwitch = { ...enabledSettings }
        updateSwitch[key]['switch'] = e.target.checked
        setEnabledSettings(updateSwitch)
        /* setEnabledSettings((prevState) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                switch: prevState[key]?.switch === true ? false : true,
            },
        })); */
        extraOptionsSave(e, key, opt)
    };

    useEffect(() => {
        window.securitySetData = enabledSettings;
    }, [enabledSettings]);

    useEffect(() => {

        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setIsPopupVisible(false);
                setPopupData(null);
                setPopupInputValue({});
            }
        };

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);

    const handleOpenPopup = (data) => {
        setExtType(data.key)
        setPopupData(data);
        const initialPopupInputValue = {};
        Object.keys(data.formField).forEach(key => {
            initialPopupInputValue[key] = enabledSettings[key] || '';
        });
        setPopupInputValue(initialPopupInputValue);
        setIsPopupVisible(true);

        if(data && data.key=='limit-login-attempt'){
            setProcessLoginData(true)
            fetch(nxtext_ajax_object?.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'nexter_ext_get_login_attempt_data',
                    nexter_nonce: nxtext_ajax_object?.ajax_nonce
                })
            })
            .then(res => res.json())
            .then(response => {
                if (response.success) {
                    setLoginData(response.data);
                } else {
                    setLoginData([]);
                }
                setProcessLoginData(false)
            })
            .catch(() => {
                setLoginData([]);
                setProcessLoginData(false)
            });
        }
    };

    const handleClosePopup = () => {
        setIsPopupVisible(false);
        setPopupData(null);
        setPopupInputValue({});
    };

    const handlePopupInputChange = (key, value) => {
        setPopupInputValue(prevState => ({
            ...prevState,
            [key]: value,
        }));
    };

    const handlePopupSave = async (e) => {
        let popWrap = e.target.closest('.nxtext_settings_popup');
        let cardWrap = popWrap.querySelector('.nxtext_field_card_cover');
    
        let getID = cardWrap.getAttribute('id');
        if (popupData) {
            setEnabledSettings((prevState) => ({
                ...prevState,
                ...popupInputValue,
            }));

            const formData = new FormData();
            formData.append('action', 'nexter_ext_save_data');
            formData.append('extension_type', getID);
            if(getID == 'advance-security'){
                const values = { ...enabledSettings[getID].values };
                formData.append('securData', JSON.stringify(values));
            }else if(getID == 'custom-login'){
                formData.append('nxtctmLogin', JSON.stringify(enabledSettings[getID].values));
            }else if(getID == 'email-login-notification'){
                formData.append('wpEmailNotiSet', JSON.stringify(enabledSettings[getID].values));
            }else if(getID == '2-fac-authentication'){
                formData.append('allowed_2fa_roles', JSON.stringify(enabledSettings[getID].values['allowed_2fa_roles']));
                formData.append('customEmailSubject', enabledSettings[getID].values['email_customisations']['subject']);
                formData.append('customEmailBody', enabledSettings[getID].values['email_customisations']['body']);
            }else if(getID == 'captcha-security'){
                formData.append('captchaSetting', JSON.stringify(enabledSettings[getID].values));
            }else if(getID == 'wp-right-click-disable'){
                formData.append('wpDisableSet', JSON.stringify(enabledSettings[getID].values));
            }else if(getID == 'svg-upload'){
                formData.append('svgUploadRoles', JSON.stringify(enabledSettings[getID].values)); 
            }else if(getID == 'limit-login-attempt'){
                formData.append('limitLogin', JSON.stringify(enabledSettings[getID].values)); 
            }else if(getID == 'block-ai-crawlers'){
                // For block-ai-crawlers, we just need to save the switch state
                // The plugin manages its own settings via WordPress options API
                formData.append('blockAiCrawlers', JSON.stringify(enabledSettings[getID].values)); 
            }
            
            formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
            
            await nxtdash_save_data(e, formData)

            setTimeout(() => {
                handleClosePopup();    
            }, 300);
        }
    };

    const Drop_down_toggle = (e) => {
        let main_object = e.target.closest(".nxtext_cstm_dropdown")
        let drop_down = main_object.querySelector(".nxtext_cstm_dropdown_content") ? main_object.querySelector(".nxtext_cstm_dropdown_content") : "";
        if (drop_down) {
            if (Object.values(drop_down.classList).includes("nxt_wp_show")) {
                drop_down.classList.remove("nxt_wp_show");
            } else {
                drop_down.classList.add("nxt_wp_show");
            }
        }
    }

    const changeDropdownVal = (e, id, name, field) => {        
        if(field == 'disable_rest_api'){
            setselectedRestApi(name) 
        }else if(field == 'iframe_security'){
            setselectedIframe(name)
        }
        let updatedSettings = { ...enabledSettings };
        updatedSettings['advance-security'].values[field] = id;
        setEnabledSettings(updatedSettings);        
    }

    const advancedCheckbox = (e, field) => {
        const updatedSettings = { ...enabledSettings };
        const advSecVal = updatedSettings['advance-security']?.values || {};
        let valueToCheck = e.target.value;
        if (e.target.checked) {
            // If checked, add the value
            if (!Object.values(advSecVal).includes(valueToCheck)) {
                const newIndex = Object.keys(advSecVal).length;
                updatedSettings['advance-security'].values[newIndex] = valueToCheck;
            }
        } else {
            // If unchecked, remove the value
            const keyToRemove = Object.keys(updatedSettings).find(key => updatedSettings[key] === valueToCheck);
            if (keyToRemove) {
                delete updatedSettings[keyToRemove];
            }

            const keyToRemoveNew = Object.keys(advSecVal).find(key => advSecVal[key] === valueToCheck);
            if (keyToRemoveNew) {
                delete updatedSettings['advance-security']?.values[keyToRemoveNew];
            }
        }
        setEnabledSettings(updatedSettings);
    }

    const changeArrayToggle = (value, field) => {
        const updatedSettings = { ...enabledSettings };
    
        // Ensure nested object structure exists
        if (!updatedSettings[field]) {
            updatedSettings[field] = { values: [] };
        }
    
        if (!Array.isArray(updatedSettings[field].values)) {
            updatedSettings[field].values = [];
        }
    
        // Add or remove value
        const index = updatedSettings[field].values.indexOf(value);
        if (index > -1) {
            updatedSettings[field].values.splice(index, 1); // Remove
        } else {
            updatedSettings[field].values.push(value); // Add
        }
    
        setEnabledSettings(updatedSettings);
    };

    const hancdleCheckbox = (e, field, sub) => {        
        const updatedSettings = { ...enabledSettings };
        const index = updatedSettings[field].values[sub].indexOf(e.target.value);
        if (e.target.checked && index === -1) {
            updatedSettings[field].values[sub].push(e.target.value);
        } else if (!e.target.checked && index !== -1) {
            updatedSettings[field].values[sub].splice(index, 1);
        }
        setEnabledSettings(updatedSettings);
    }

    const handleUserAgentCheckbox = (e, field) => {
        const updatedSettings = { ...enabledSettings };
        // Initialize with all user agents if not set or empty array (default: all checked)
        if (!updatedSettings[field].values.selected_user_agents || 
            !Array.isArray(updatedSettings[field].values.selected_user_agents) ||
            updatedSettings[field].values.selected_user_agents.length === 0) {
            updatedSettings[field].values.selected_user_agents = [...ai_crawler_user_agents];
        }
        const index = updatedSettings[field].values.selected_user_agents.indexOf(e.target.value);
        if (e.target.checked && index === -1) {
            updatedSettings[field].values.selected_user_agents.push(e.target.value);
        } else if (!e.target.checked && index !== -1) {
            updatedSettings[field].values.selected_user_agents.splice(index, 1);
        }
        setEnabledSettings(updatedSettings);
    }

    const inputTexareaChange = (e, field, sub, sub2) => {
        const updatedSettings = { ...enabledSettings };
    
        let valueToCheck = e.target.value;
        if(field == 'email-login-notification'){
            if(sub == 'exclude_ips'){
                setEmailIp(valueToCheck)
                let ipArray = valueToCheck.split(',').map(ip => ip.trim());                
                updatedSettings[field].values[sub] = ipArray;
            }else{
                updatedSettings[field].values[sub] = valueToCheck;
            }
        }else if(field == '2-fac-authentication'){
            updatedSettings[field].values[sub][sub2] = valueToCheck;
        }else{
            updatedSettings[field] = valueToCheck;
        }

        setEnabledSettings(updatedSettings);
    }

    const handleChangeSettings = (dname, newVal) => {
        
        // if(newVal){            
            const newSettings = {
                ...settings,
                [dname]: newVal,
            };   
            
            setSettings(newSettings);
    
            setEnabledSettings(prevEnabledSettings => ({
                ...prevEnabledSettings,
                'wp-right-click-disable': {
                    ...prevEnabledSettings['wp-right-click-disable'],
                    values: newSettings,
                    switch: true,
                },
            }));
        // }
    }

    const tooltipSVG = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>

    return (
        <div className='nxtext_extopt_cover_main nxtext_securitytab_mainver nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('Security', 'nexter-extension')}</h3>
            </div>

            <div className='nxtext_field_card_sec_cover'>
            {SecurityData.map((setting) => (
                <div className='nxtext_field_card' key={setting.key}>
                    <div className='nxtext_card_top_detail'>
                        <div className='nxtext_field_card_h_strip'>
                            <div className='nxtext_h_with_tip'>
                                <label htmlFor={`nxt_${setting.key}`} className='nxtext_secondary_heading'>{setting.name}</label>
                                {setting.isNew &&
                                    <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                }
                                {setting.isBeta &&
                                    <div className="nxt-new-ext">{ __( "BETA", 'nexter-extension' ) }</div>
                                }
                                <div className='nxtext_tooltip'>{tooltipSVG}
                                    <span className="nxtext_tooltiptext">{setting.tooltip}</span>
                                </div>
                            </div>
                            <div className='nxtext_tgl_with_setting'>
                                {((setting.popDesc && setting.popshow != false && !setting.isPro) || (nxtext_ajax_object.pro && setting.isPro)) &&
                                    <button className={'nxt-ex-btn' + ((enabledSettings[setting.key] === "enable" || (enabledSettings && enabledSettings[setting.key] && enabledSettings[setting.key].switch == true)) ? ' enabled' : '')} disabled={(!enabledSettings[setting.key]  ||(enabledSettings && enabledSettings[setting.key] && enabledSettings[setting.key].switch != true)) } onClick={() => {(extensionInstall && ((!setting.isPro) || (nxtext_ajax_object.pro && setting.isPro))) ?handleOpenPopup(setting) : extensionInstall ? setIsPopupExtensionInstall(prev => !prev) : setIsPopupProVisible(prev => !prev) }}>{nxtds_icons.setting}</button>
                                }
                                
                                <div className="nxtext_block_tgl_btn_cover">
                                    <input className="nxtext_toggle_btn" id={`nxt_${setting.key}`} type="checkbox" checked={(enabledSettings && enabledSettings[setting.key]?.switch === true && ( (nxtext_ajax_object.pro && setting.isPro) || !setting.isPro )) ? true : false} onChange={(e) => {(extensionInstall && ((!setting.isPro) || (nxtext_ajax_object.pro && setting.isPro))) ? handleCheckboxChange(e, setting.key, "security") : ''}} onClick={() => { if (!extensionInstall) { setIsPopupExtensionInstall(prev => !prev)}else if (!nxtext_ajax_object.pro && setting.isPro) { setIsPopupProVisible(prev => !prev)} } } />
                                    <label className={"nxtext_switch_label"+(((!nxtext_ajax_object.pro && setting.isPro) || !extensionInstall) ? ' nxt-pro-lock-toggle' : '')} htmlFor={`nxt_${setting.key}`}>
                                        <span className="nxtext_switch_button"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <p className='nxtext_paragrph'>
                            {setting.desc}
                            {setting.link && <a href={setting.link.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{setting.link.text}</a>}
                        </p>
                        {setting.doclink && !(nxtext_ajax_object?.dashData?.whiteLabel?.nxt_help_link == 'on') &&
                            <div className='nxtext_links_cover'>
                                <a target="_blank" rel="noopener noreferrer" href={setting.doclink || '#'} className='nxtext_tertiary_btn nxtext_paragraph'>{__('Read Docs', 'nexter-extension')}</a>
                            </div>
                        }
                    </div>
                    {!nxtext_ajax_object.pro && setting.isPro &&
                        <div className="nxt-beta-ext">{ __( "PRO", 'nexter-extension' ) }</div>
                    }
                    {!nxtext_ajax_object.pro && setting.isFreemium &&
                        <div className="nxt-beta-ext">{ __( "Freemium", 'nexter-extension' ) }</div>
                    }
                </div>
            ))}
            </div>


            {isPopupVisible &&
                <>
                    <div className='nxtext_overlay' onClick={handleClosePopup}></div>
                    <div className={`nxtext_settings_popup ${extType}-popup`}>
                        <svg className='nxtext_close_icon' draggable={false} onClick={handleClosePopup} xmlns="http://www.w3.org/2000/svg" width="36" height="17" fill="none" viewBox="0 0 36 17"><path fill="#414B5A" d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z" /></svg>
                        <div className='nxtext_popup_heading'>
                            <h3 className='nxtext_primary_heading'>{popupData.name}</h3>
                            <p className='nxtext_paragrph' dangerouslySetInnerHTML={{ __html: popupData.popDesc }}></p>

                            {/* {popupData.poplink && <a href={popupData.poplink.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{popupData.poplink.text}</a>} */}

                        </div>
                        <div className='nxtext_popup_inner_main_co'>
                            {Object.keys(popupData.formField).map((key) => {
                                const field = popupData.formField[key];
                                if(key == 'label'){
                                    return
                                }
                                return (
                                    <div className='nxtext_field_card_cover' key={field} id={field}>
                                        <div className='nxtext_pop_in_cover'>
                                            {field === 'advance-security' && (
                                                <>
                                                    <div className='nxtext_security_datacover'>
                                                        {adv_security_data_toggle.map((item) => (
                                                            <div className='nxtext_strip_tgl_cover' key={item.id}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                                                                    <div className='nxtext_tooltip'>{tooltipSVG}
                                                                        <span className="nxtext_tooltiptext">{item.tooltip}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item.id} value={item.id} type="checkbox" checked={(enabledSettings && Object.values(enabledSettings[field]?.values).includes(item.id)) ? true : false} onChange={(e)=>{advancedCheckbox(e)}}/>
                                                                        <label className="nxtext_switch_label" htmlFor={item.id}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        }
                                                        {adv_security_data_select.map((item) => (
                                                            <div className='nxtext_strip_tgl_cover' key={item.id}>
                                                            <div className='nxtext_strip_tgl_h'>
                                                                <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                                                                <div className='nxtext_tooltip'>{tooltipSVG}
                                                                    <span className="nxtext_tooltiptext">{item.tooltip}</span>
                                                                </div>
                                                            </div>
                                                            <div className='nxtext_cstm_dropdown' onClick={(e) => { Drop_down_toggle(e) }}>
                                                                <div className='nxtext_cstm_dropdown_header'>
                                                                    <label className='nxt_paragraph' htmlFor="nxt_rollVersion">{(item.id == 'iframe_security') ? selectedIframe : selectedRestApi}</label>
                                                                    <img src={plugin_url + 'assets/svg/nxt_chevron_down.svg'} draggable={false} />
                                                                </div>
                                                                <div id="nxt_rollVersion" className='nxtext_cstm_dropdown_content'>
                                                                    {Object.entries(item.options).map(([key, value]) => (
                                                                        <div className='nxt-option' key={key} value={key} onClick={(ev) => changeDropdownVal(ev, key, value, item.id)}>{value}</div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        ))
                                                        }
                                                        {adv_security_data_toggle2.map((item) => (
                                                            <div className='nxtext_strip_tgl_cover' key={item.id}>
                                                                {!nxtext_ajax_object.pro && item.isPro &&
                                                                    <div className="nxt-inner-pro-tag">{ __( "PRO", 'nexter-extension' ) }</div>
                                                                }
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item.id}>{item.name}</label>
                                                                    {item.isNew &&
                                                                        <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                                                    }
                                                                    <div className='nxtext_tooltip'>{tooltipSVG}
                                                                        <span className="nxtext_tooltiptext">{item.tooltip}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item.id} value={item.id} type="checkbox" checked={(enabledSettings && Object.values(enabledSettings[field]?.values).includes(item.id) && ( (nxtext_ajax_object.pro && item.isPro) || !item.isPro )) ? true : false} onChange={(e)=>{(!nxtext_ajax_object.pro && item.isPro) ? setIsPopupProVisible(prev => !prev) : advancedCheckbox(e)}}/>
                                                                        <label className="nxtext_switch_label" htmlFor={item.id}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </>
                                            )}

                                            {field === 'captcha-security' && (
                                                <>
                                                <div className='nexter-captcha_switcher'>
                                                    <div className={'nxt-captcha-switch bdr_rad_left '+((enabledSettings[field]?.values?.['captcha_type'] == 'google') ? 'active' : '')} onClick={(e) => {
                                                        const updatedSettings = { ...enabledSettings };
                                                        updatedSettings[field]['values']['captcha_type'] = 'google';
                                                        setEnabledSettings(updatedSettings);
                                                    }}>{__('Google reCAPTCHA', 'nexter-extension')}</div>
                                                    <div className={'nxt-captcha-switch bdr_rad_right '+((enabledSettings[field]?.values?.['captcha_type'] == 'cloudflare') ? 'active' : '')} onClick={(e) => {
                                                        const updatedSettings = { ...enabledSettings };
                                                        updatedSettings[field]['values']['captcha_type'] = 'cloudflare';
                                                        setEnabledSettings(updatedSettings);
                                                    }}>{__('Cloudflare Turnstile', 'nexter-extension')}</div>
                                                </div>
                                                <div className='nxtext_captcha_main_cover'>
                                                    <div className='nxtext_key_fields'>
                                                        <div className='nxtext_field_with_lbl'>
                                                            <div className='nxtext_field_card_h_strip'>
                                                                <div className='nxtext_h_with_tip nxtext_topkeys_lbl_tips'>
                                                                    <label className='nxtext_secondary_heading'>{__('Site Key', 'nexter-extension')}</label>
                                                                    <div className='nxtext_tooltip'>{tooltipSVG}
                                                                        <span className="nxtext_tooltiptext">{enabledSettings[field]?.values?.['captcha_type'] == 'google' ? __('Add Google reCAPTCHA Site Key.', 'nexter-extension') : __('Add Cloudflare Turnstile reCAPTCHA Site Key.', 'nexter-extension')}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <input
                                                                id="site"
                                                                className="nxtext_text_field"
                                                                name={
                                                                    enabledSettings[field]?.values?.['captcha_type'] === 'google'
                                                                    ? 'nexter_re_public_key'
                                                                    : 'nexter_turnstile_key'
                                                                }
                                                                value={
                                                                    enabledSettings[field]?.values?.[
                                                                    enabledSettings[field]?.values?.['captcha_type'] === 'google'
                                                                        ? 'siteKey'
                                                                        : 'turnSiteKey'
                                                                    ] || ''
                                                                }
                                                                type="text"
                                                                placeholder={
                                                                    enabledSettings[field]?.values?.['captcha_type'] === 'google'
                                                                    ? __('Please Enter Site Key', 'nexter-extension')
                                                                    : __('Please Enter Turnstile Site Key', 'nexter-extension')
                                                                }
                                                                onChange={(e) => {
                                                                    const updatedSettings = { ...enabledSettings };
                                                                    if (enabledSettings[field]?.values?.['captcha_type'] === 'google') {
                                                                    updatedSettings[field]['values']['siteKey'] = e.target.value;
                                                                    } else {
                                                                    updatedSettings[field]['values']['turnSiteKey'] = e.target.value;
                                                                    }
                                                                    setEnabledSettings(updatedSettings);
                                                                }}
                                                            />
                                                        </div>

                                                        <div className='nxtext_field_with_lbl'>
                                                            <div className='nxtext_field_card_h_strip'>
                                                                <div className='nxtext_h_with_tip nxtext_topkeys_lbl_tips'>
                                                                    <label className='nxtext_secondary_heading'>{__('Secret Key', 'nexter-extension')}</label>
                                                                    <div className='nxtext_tooltip'>{tooltipSVG}
                                                                        <span className="nxtext_tooltiptext">{enabledSettings[field]?.values?.['captcha_type'] == 'google' ? __('Add Google reCAPTCHA Secret Key.', 'nexter-extension') : __('Add Cloudflare Turnstile reCAPTCHA Secret Key.', 'nexter-extension')}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <input
                                                                id="secret"
                                                                className="nxtext_text_field"
                                                                name={
                                                                    enabledSettings[field]?.values?.['captcha_type'] === 'google'
                                                                    ? 'nexter_re_private_key'
                                                                    : 'nexter_turnstile_secret'
                                                                }
                                                                value={
                                                                    enabledSettings[field]?.values?.[
                                                                    enabledSettings[field]?.values?.['captcha_type'] === 'google'
                                                                        ? 'secretKey'
                                                                        : 'turnSecretKey'
                                                                    ] || ''
                                                                }
                                                                type="text"
                                                                placeholder={
                                                                    enabledSettings[field]?.values?.['captcha_type'] === 'google'
                                                                    ? __('Please Enter Secret Key', 'nexter-extension')
                                                                    : __('Please Enter Turnstile Secret Key', 'nexter-extension')
                                                                }
                                                                onChange={(e) => {
                                                                    const updatedSettings = { ...enabledSettings };
                                                                    if (enabledSettings[field]?.values?.['captcha_type'] === 'google') {
                                                                    updatedSettings[field]['values']['secretKey'] = e.target.value;
                                                                    } else {
                                                                    updatedSettings[field]['values']['turnSecretKey'] = e.target.value;
                                                                    }
                                                                    setEnabledSettings(updatedSettings);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {enabledSettings[field]?.values?.['captcha_type'] == 'google' ?
                                                        <div className='nxtext_paragrph' style={{ marginTop: '-10px' }}>
                                                            {__('The Generate Site Key and Secret key', 'nexter-extension')}{' '}
                                                            <a
                                                                href="https://www.google.com/recaptcha/admin/create#list"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className='nxtext_tertiary_btn'
                                                            >
                                                                {__('Google reCAPTCHA', 'nexter-extension')}
                                                            </a>
                                                        </div>
                                                        :
                                                        <div className='nxtext_paragrph' style={{ marginTop: '-10px' }}>
                                                            {__('The Generate Site Key and Secret key', 'nexter-extension')}{' '}
                                                            <a
                                                                href="https://dash.cloudflare.com/?to=%2F:account%2Fturnstile"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className='nxtext_tertiary_btn'
                                                            >
                                                                {__('Cloudflare Turnstile dashboard', 'nexter-extension')}
                                                            </a>
                                                        </div>
                                                    }
                                                    
                                                    {captcha_options.map((section, index) => (
                                                        <div className="nxtext_checkbox_stripver" key={index}>
                                                            <div className='nxtext_h_with_tip'>
                                                            <div className='nxtext_secondary_heading'>{section.title}</div>
                                                                {section.tooltip && (
                                                                    <div className='nxtext_tooltip'>
                                                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                        <span className="nxtext_tooltiptext">{section.tooltip}</span>
                                                                    </div>
                                                                )}
                                                                { section.name != 'formType' && "nexter_recaptcha_woo" != section.name && <span className="nxt-captcha-cs cs-with-gap">{__('Coming Soon', 'nexter-extension')}</span>}
                                                                {section.name =='nexter_recaptcha_woo' && !woocommerce_exists && <span style={{fontSize: '10px', backgroundColor: 'rgb(43, 43, 43)', color: 'white', padding: '2px 6px', borderRadius: '30px', fontWeight: '500', marginLeft: '8px', lineHeight: '16px', opacity: '0.5'}}>{__('NOT INSTALLED', 'nexter-extension')}</span>}
                                                            </div>
                                                            {section.checkboxes.map((group, index) => (
                                                            <div className="nxtext_capsecu_checkstrip" key={index}>
                                                                {group.map(({ id, label, disabled, locked }) => (
                                                                    <div className={"nxtext_checkbox_inn_cover "+((disabled) ? 'hover-disabled' : '')}>
                                                                    <input type="checkbox" name={section.name} id={id} value={id} className="nxtext_text_field checkbox_style" disabled={disabled} style={{ opacity: disabled ? 0 : 1 }} onChange={(e) => { 
                                                                        // if(section.name == 'nexter_recaptcha_enable'){
                                                                            hancdleCheckbox(e, field, 'formType')
                                                                        // }
                                                                    }} checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values['formType'] && enabledSettings[field].values['formType'].includes(id)}/>
                                                                    <label htmlFor={id} className={"nxtext_paragrph "+(disabled ? 'nxt-text-disabled' : '')}>{label}</label>
                                                                    {locked && lockedSVG()}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                                </>
                                            )}

                                            {field === 'wp-right-click-disable' && (
                                                <>
                                                <Nexter_Tabs>
                                                    <Nexter_Tab tabTitle={__('Protections', 'nexter-extension')}>
                                                        <div className='nxtext_content nxtext_content_protcover'>
                                                            <div className='nxtext_secondary_heading'>{__('Who Can Access', 'nexter-extension')}</div>
                                                            <div className="nxtext_cloud_checkbox nxtext_contchecks_protcover">
                                                                {Object.entries(all_users_list).map(([id, name], index, array) => (
                                                                    <div className={"nxtext_cloud_checkbox_div " +(index === 0 ? "cloud_border_remove_r" : index === array.length - 1 ? "cloud_border_remove_l" : "content_border_add")} key={index.toString()}>
                                                                        <input type="checkbox" id={id} className="nxtext_text_field checkbox_style" value={id} onChange={(e) => { 
                                                                            let getAllList = enabledSettings[field]?.values?.['disable_access'] || []
                                                                            const index = getAllList.indexOf(e.target.value);

                                                                            if (e.target.checked && index === -1) {
                                                                                getAllList.push(e.target.value);
                                                                            } else if (!e.target.checked && index !== -1) {
                                                                                getAllList.splice(index, 1);
                                                                            }

                                                                            handleChangeSettings('disable_access', getAllList)
                                                                        }} checked={(enabledSettings?.[field]?.values?.['disable_access'] || []).includes(id)}/>
                                                                        <label htmlFor={id} className="nxtext_paragrph">{name}</label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className='nxtext_content_wrap nxtext_contprotect_cover_main'>
                                                                {Object.entries(content_protection_list).map(([id, name]) => (
                                                                    <div className='nxtext_content_main_div' key={id}>
                                                                        <div className='nxtext_content_inner_div'>
                                                                            <label htmlFor={id} className='nxtext_secondary_heading'>{name}</label>
                                                                            <div className="nxtext_block_tgl_btn_cover">
                                                                                <input className="nxtext_toggle_btn" id={id} type="checkbox" onChange={(e)=>{
                                                                                    if(e.target.checked){
                                                                                        handleChangeSettings(id, true)
                                                                                    }else{
                                                                                        handleChangeSettings(id, false)
                                                                                    }
                                                                                }} checked={settings[id]}/>
                                                                                <label className="nxtext_switch_label" htmlFor={id}>
                                                                                    <span className="nxtext_switch_button"></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <div className='nxtext_contprot_inputfield'>
                                                                            <input id={id+"-msg"} className="nxtext_text_field nxtext_content_protection" placeholder="Message" type="text" value={settings[id+"-msg"] || ''} onChange={(e)=>{
                                                                                handleChangeSettings(id+"-msg", e.target.value)
                                                                            }} disabled={!settings[id]}/>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Nexter_Tab>
                                                    <Nexter_Tab tabTitle={__('Customisation', 'nexter-extension')}>
                                                        <div className='nxtext_content nxtext_content_protcover'>
                                                            <div className="nxtext_cloud_checkbox nxtext_contchecks_protcover">
                                                                <div className='nxtext_content_wrap nxtext_contprotect_cover_main'>
                                                                    <Nexter_Label_Heading
                                                                        label={ __( "Notice Style", 'nexter-extension' ) }
                                                                    />
                                                                    <div className='nxtext_content_main_div cover-full-width remove_cnt_gap'>
                                                                        <Nexter_RadioAdvanced
                                                                            name="alert-pos"
                                                                            label={__('Message Position', 'nexter-extension')}
                                                                            value={settings['alert-pos'] || 'left'}
                                                                            responsive={false}
                                                                            onChange={(value)=>{handleChangeSettings('alert-pos', value)}}
                                                                            options={ [
                                                                                { label: __('Top Right', 'nexter-extension'), value: 'top_right', title: __('Top Right', 'nexter-extension'), svg: Nexter_Icons.cnttopmsg },
                                                                                { label: __('Bottom Right', 'nexter-extension'), value: 'bottom_right', title: __('Bottom Right', 'nexter-extension'), svg: Nexter_Icons.cntbottommsg },
                                                                            ]  }
                                                                            inlineblock={false}
                                                                            diff={'top_right'}
                                                                        />
                                                                        <Nexter_Text
                                                                            label={__('Message Disappear Time(ms)', 'nexter-extension')}
                                                                            type={"number"}
                                                                            value={settings['alert-dis-time'] || '3000'}
                                                                            onChange={(value) => {handleChangeSettings( 'alert-dis-time', value )}}
                                                                            diff = { '3000' }
                                                                            inlineblock={true}
                                                                        />
                                                                        <Nexter_Typography 
                                                                            label={ __('Title Typography', 'nexter-extension') } 
                                                                            name="titleTypo"
                                                                            value={ settings.titleTypo || defaultTypo}
                                                                            onChange={ ( value ) => {handleChangeSettings('titleTypo', value)} } 
                                                                            device = { device } 
                                                                            onDeviceChange = { ( value ) => setDevice(value) }
                                                                            separator = {'default'}
                                                                            diff = { defaultTypo }
                                                                        />
                                                                        <Nexter_Typography 
                                                                            label={ __('Description Typography', 'nexter-extension') } 
                                                                            name="formTTypo"
                                                                            value={ settings.descTypo || defaultTypo}
                                                                            onChange={ ( value ) => {handleChangeSettings('descTypo', value)} } 
                                                                            device = { device } 
                                                                            onDeviceChange = { ( value ) => setDevice(value) }
                                                                            separator = {'default'}
                                                                            diff = { defaultTypo }
                                                                        />
                                                                        <Nexter_Dimension 
                                                                            label={__('Padding', 'nexter-extension')}
                                                                            name="formBoxPadding"
                                                                            value={ settings.messPadding || defaultDimension}
                                                                            openPadding = {true}
                                                                            onChange={ ( value ) => {handleChangeSettings('messPadding', value)} }
                                                                            min= {0}
                                                                            max={100}
                                                                            unit= {['px','%']}
                                                                            responsive={ true }
                                                                            device= {device}
                                                                            onDeviceChange = { ( value ) => setDevice(value) }
                                                                            diff = { defaultDimension }
                                                                        />
                                                                        <Nexter_Tabs>
                                                                            <Nexter_Tab tabTitle={__('Background', 'nexter-extension')}>
                                                                                <Nexter_Color 
                                                                                    name="formTColor"
                                                                                    label={ __('Background Color', 'nexter-extension') } 
                                                                                    disableGlobal ={true}
                                                                                    value={settings['msg-bg-color'] || ''}
                                                                                    onChange={(value)=>{handleChangeSettings('msg-bg-color', value)}}
                                                                                    separator = {''} 
                                                                                    diff={''}
                                                                                />
                                                                            </Nexter_Tab>
                                                                            <Nexter_Tab tabTitle={__('Border', 'nexter-extension')}>
                                                                                <Nexter_Color 
                                                                                    name="formTColor"
                                                                                    label={ __('Border Color', 'nexter-extension') } 
                                                                                    disableGlobal ={true}
                                                                                    value={settings['msg-border-color'] || ''}
                                                                                    onChange={(value)=>{handleChangeSettings('msg-border-color', value)}}
                                                                                    separator = {''} 
                                                                                    diff={''}
                                                                                />
                                                                            </Nexter_Tab>
                                                                            <Nexter_Tab tabTitle={__('Title', 'nexter-extension')}>
                                                                                <Nexter_Color 
                                                                                    name="formTColor"
                                                                                    label={ __('Title Color', 'nexter-extension') } 
                                                                                    disableGlobal ={true}
                                                                                    value={settings['msg-title-color'] || ''}
                                                                                    onChange={(value)=>{handleChangeSettings('msg-title-color', value)}}
                                                                                    separator = {''} 
                                                                                    diff={''}
                                                                                />
                                                                            </Nexter_Tab>
                                                                            <Nexter_Tab tabTitle={__('Description', 'nexter-extension')}>
                                                                                <Nexter_Color 
                                                                                    name="formTColor"
                                                                                    label={ __('Description Color', 'nexter-extension') } 
                                                                                    disableGlobal ={true}
                                                                                    value={settings['msg-desc-color'] || ''}
                                                                                    onChange={(value)=>{handleChangeSettings('msg-desc-color', value)}}
                                                                                    separator = {''} 
                                                                                    diff={''}
                                                                                />
                                                                            </Nexter_Tab>
                                                                            <Nexter_Tab tabTitle={__('Icon', 'nexter-extension')}>
                                                                                <Nexter_Color 
                                                                                    name="formTColor"
                                                                                    label={ __('Icon Color', 'nexter-extension') } 
                                                                                    disableGlobal ={true}
                                                                                    value={settings['msg-icon-color'] || ''}
                                                                                    onChange={(value)=>{handleChangeSettings('msg-icon-color', value)}}
                                                                                    separator = {''} 
                                                                                    diff={''}
                                                                                />
                                                                            </Nexter_Tab>
                                                                            <Nexter_Tab tabTitle={__('Progress', 'nexter-extension')}>
                                                                                <Nexter_Color 
                                                                                    name="formTColor"
                                                                                    label={ __('Icon Background/Progress Color', 'nexter-extension') } 
                                                                                    disableGlobal ={true}
                                                                                    value={settings['msg-icon-bg-progress'] || ''}
                                                                                    onChange={(value)=>{handleChangeSettings('msg-icon-bg-progress', value)}}
                                                                                    separator = {''} 
                                                                                    diff={''}
                                                                                />
                                                                            </Nexter_Tab>
                                                                        </Nexter_Tabs>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Nexter_Tab>
                                                </Nexter_Tabs>
                                                </>
                                            )}

                                            {field === 'custom-login' && (
                                                <div className='nxtext_custom_login'>
                                                    <div className='nxtext_custom_login_outer'>
                                                        <div className='nxtext_custom_login_inner nxtext_change_wp_cover'>
                                                            <div className='nxtext_h_with_tip'>
                                                                <label htmlFor='WPloginPath' className='nxtext_secondary_heading'>{__('Change WP Admin Login Path', 'nexter-extension')}</label>
                                                                <div className='nxtext_tooltip'>{tooltipSVG}
                                                                    <span className="nxtext_tooltiptext bottom_tooltip">{__('Add the custom login path.', 'nexter-extension')}</span>
                                                                </div>
                                                            </div>
                                                            <input type="text" id="WPloginPath" className="nxtext_text_field" placeholder={__('Please enter your custom path e.g. new-login-page', 'nexter-extension')} value={enabledSettings[field]?.values?.custom_login_url || ''} onChange={(e)=> {
                                                                const updatedSettings = { ...enabledSettings };
                                                                if (updatedSettings[field]) {
                                                                    updatedSettings[field].values.custom_login_url = e.target.value;
                                                                }
                                                                setEnabledSettings(updatedSettings);
                                                            } } />
                                                        </div>
                                                    </div>
                                                    <div className='nxtext_custom_login_outer'>
                                                        <div className='nxtext_custom_login_inner'>

                                                            <div className='nxtext_h_with_tip'>
                                                                <div className='nxtext_secondary_heading'>{__('Login URL Behaviour', 'nexter-extension')}</div>
                                                                <div className='nxtext_tooltip'>{tooltipSVG}
                                                                    <span className="nxtext_tooltiptext">{__('Set the action for the old login URL.', 'nexter-extension')}</span>
                                                                </div>
                                                            </div>
                                                            <div className='nxtext_cstm_dropdown' onClick={(e) => { Drop_down_toggle(e) }}>
                                                                <div className='nxtext_cstm_dropdown_header'>
                                                                    <label className='nxt_paragraph' htmlFor="nxt_rollVersion">{login_behaviour[enabledSettings[field]?.values?.disable_login_url_behavior]}</label>
                                                                    <img src={plugin_url + 'assets/svg/nxt_chevron_down.svg'} draggable={false} />
                                                                </div>
                                                                <div id="nxt_rollVersion" className='nxtext_cstm_dropdown_content'>
                                                                    {Object.entries(login_behaviour).map(([id, name]) => (
                                                                        <div key={id} className='nxt-option' value={id} onClick={() => {
                                                                            const updatedSettings = { ...enabledSettings };
                                                                            if (updatedSettings[field]) {
                                                                                updatedSettings[field].values.disable_login_url_behavior = id;
                                                                            }
                                                                            setEnabledSettings(updatedSettings);
                                                                        }}>{name}</div>
                                                                        ))}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    { enabledSettings[field]?.values?.disable_login_url_behavior == 'message' &&
                                                        <div className='nxtext_custom_login_outer'>
                                                            <div className='nxtext_custom_login_inner'>

                                                                <div className='nxtext_h_with_tip'>
                                                                    <div className='nxtext_secondary_heading'>{__('Custom Message', 'nexter-extension')}</div>
                                                                    <div className='nxtext_tooltip'>{tooltipSVG}
                                                                        <span className="nxtext_tooltiptext">{__('Display a custom message for users accessing the old login URL.', 'nexter-extension')}</span>
                                                                    </div>
                                                                </div>

                                                                <textarea id="review" name="review" className='nxtext_custom_login_textarea' onChange={(e)=> {
                                                                const updatedSettings = { ...enabledSettings };
                                                                if (updatedSettings[field]) {
                                                                    updatedSettings[field].values.login_page_message = e.target.value;
                                                                }
                                                                setEnabledSettings(updatedSettings);
                                                            } } value={enabledSettings[field]?.values?.login_page_message || ''} />
                                                            </div>
                                                        </div>
                                                    }
                                                    
                                                </div>
                                            )}
                                            {field === 'svg-upload' && (
                                                <div className="nxtext_cloud_checkbox">
                                                {Object.entries(all_users_list).map(([id, name], index, array) => (
                                                    <div className={"nxtext_cloud_checkbox_div " +(index === 0 ? "cloud_border_remove_r" : index === array.length - 1 ? "cloud_border_remove_l" : "content_border_add")} key={index.toString()}>
                                                        <input type="checkbox" id={id} className="nxtext_text_field checkbox_style" value={id} onChange={() => { changeArrayToggle(id, field) }} checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values.includes(id)) ? true : false} />
                                                        <label htmlFor={id} className="nxtext_paragrph">{name}</label>
                                                    </div>
                                                ))}
                                            </div>
                                            )}
                                            {field === '2-fac-authentication' && (
                                                <div className='nxtext_factor_auth_main_div '>
                                                    <div className='nxtext_factor_auth'>
                                                        <div className='nxtext_secondary_heading'>{__('Which User Roles are allowed', 'nexter-extension')}</div>
                                                        <div className="nxtext_cloud_checkbox">
                                                            {Object.entries(all_users_list).map(([id, name], index, array) => (
                                                                <div className={"nxtext_cloud_checkbox_div " +(index === 0 ? "cloud_border_remove_r" : index === array.length - 1 ? "cloud_border_remove_l" : "content_border_add")} key={index.toString()}>
                                                                    <input type="checkbox" id={id} className="nxtext_text_field checkbox_style" value={id} onChange={(e) => { hancdleCheckbox(e, field, 'allowed_2fa_roles') }} checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values['allowed_2fa_roles'].includes(id)}/>
                                                                    <label htmlFor={id} className="nxtext_paragrph">{name}</label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className='nxtext_secondary_heading nxtext_product_name'>{__('2A Email Customizations', 'nexter-extension')}</div>
                                                        <div className='nxtext_field_with_lbl'>
                                                            <div className='nxtext_secondary_heading'>{__('Custom Email Subject', 'nexter-extension')}</div>
                                                            <input type="text" id="new_txt" className="nxtext_text_field" placeholder='Your 2FA Verification Code for [SiteName]' value={(enabledSettings && enabledSettings['2-fac-authentication'] && enabledSettings['2-fac-authentication'].values['email_customisations']['subject']) ? enabledSettings['2-fac-authentication'].values['email_customisations']['subject'] : ''} onChange={(e)=>{inputTexareaChange(e, field, 'email_customisations', 'subject')}}/>
                                                        </div>
                                                        <div className='nxtext_field_with_lbl'>
                                                            <div className='nxtext_secondary_heading'>{__('Custom Email Message', 'nexter-extension')}</div>
                                                            <textarea id="review" name="review" className='nxtext_factor_auth_textarea' onChange={(e)=>{inputTexareaChange(e, field, 'email_customisations', 'body')}}>
                                                            {(enabledSettings && enabledSettings['2-fac-authentication'] && enabledSettings['2-fac-authentication'].values['email_customisations']['body']) ? enabledSettings['2-fac-authentication'].values['email_customisations']['body'] : ''}
                                                            </textarea>
                                                        </div>
                                                        <div className='nxtext_paragrph'>{__('You can use hottags username for username, nicename for Name, token for One time token and time for time', 'nexter-extension')}</div>
                                                    </div>
                                                </div>
                                            )}

                                            {field === 'email-login-notification' && (
                                                <div className='nxtext_email_noti_main_div'>
                                                    <div className='nxtext_email_noti'>
                                                        <div className='nxtext_secondary_heading'>{__('Who Get Alert', 'nexter-extension')}</div>
                                                        <div className="nxtext_cloud_checkbox">
                                                            {Object.entries(all_users_list).map(([id, name], index, array) => (
                                                                <div className={"nxtext_cloud_checkbox_div " +(index === 0 ? "cloud_border_remove_r" : index === array.length - 1 ? "cloud_border_remove_l" : "content_border_add")} key={index.toString()}>
                                                                    <input type="checkbox" id={id} className="nxtext_text_field checkbox_style" value={id} onChange={(e) => { hancdleCheckbox(e, field, 'get_alert') }} checked={enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values['get_alert'].includes(id)}/>
                                                                    <label htmlFor={id} className="nxtext_paragrph">{name}</label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className='nxtext_field_with_lbl'>
                                                            <label className='nxtext_secondary_heading'>{__('Exclude IPs', 'nexter-extension')}</label>
                                                            <input type="text" id="new_txt" className="nxtext_text_field" placeholder='Enter Exclude IPs' value={emailIp} onChange={(e)=>{ inputTexareaChange(e, field, 'exclude_ips', '')}}/>
                                                        </div>
                                                        <div className='nxtext_paragrph'>
                                                            {__('Get your IP Address from', 'nexter-extension')}{' '}
                                                            <a className='nxtext_tertiary_btn' href="https://whatismyipaddress.com" target="_blank" rel="noopener noreferrer">
                                                                {__('whatismyipaddress.com', 'nexter-extension')}
                                                            </a>
                                                            . {__('You can also add multiple IPs using a comma in between. E.g. 192.168.1.XX, 10.0.0.XX', 'nexter-extension')}
                                                        </div>
                                                        <div className='nxtext_field_with_lbl'>
                                                            <label className='nxtext_secondary_heading'>{__('Subject', 'nexter-extension')}</label>
                                                            <input type="text" id="new_txt" className="nxtext_text_field" placeholder='New Login Detected at [SiteName]' value={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values['subject']) ?enabledSettings[field].values['subject'] : ''} onChange={(e)=>{ inputTexareaChange(e, field, 'subject', '')}}/>
                                                        </div>
                                                        <div className='nxtext_field_with_lbl'>
                                                            <label className='nxtext_secondary_heading'>{__('Message', 'nexter-extension')}</label>
                                                            <textarea id="review" name="review" className='nxtext_factor_auth_textarea nxtext_email_noti_textarea' onChange={(e)=>{ inputTexareaChange(e, field, 'alert_message', '')}}>
                                                               {(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values['alert_message']) ?enabledSettings[field].values['alert_message'] : '' }
                                                            </textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {field === 'block-ai-crawlers' && (
                                                <div className='nxtext_block_ai_crawlers_main_div'>
                                                    <div className='nxtext_block_ai_crawlers'>
                                                        <div className='nxtext_h_with_tip'>
                                                            <div className='nxtext_secondary_heading'>{__('Select User Agents to Block', 'nexter-extension')}</div>
                                                            <div className='nxtext_tooltip'>{tooltipSVG}
                                                                <span className="nxtext_tooltiptext">{__('Select which AI crawler user agents to block. Unselected agents will not be blocked.', 'nexter-extension')}</span>
                                                            </div>
                                                        </div>
                                                        <div className="nxtext_block_ai_user_agents_checkbox">
                                                            {ai_crawler_user_agents.map((userAgent, index) => {
                                                                const selectedAgents = enabledSettings[field]?.values?.selected_user_agents;
                                                                // If selected_user_agents is not set or is empty array, default to checked (all selected)
                                                                // If it's set and not empty, check if this agent is in the array
                                                                const isChecked = !selectedAgents || selectedAgents.length === 0 || selectedAgents.includes(userAgent);
                                                                return (
                                                                    <div className="nxtext_checkbox_inn_cover" key={userAgent}>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            id={`user-agent-${userAgent}`} 
                                                                            value={userAgent} 
                                                                            className="nxtext_text_field checkbox_style" 
                                                                            onChange={(e) => handleUserAgentCheckbox(e, field)}
                                                                            checked={isChecked}
                                                                        />
                                                                        <label htmlFor={`user-agent-${userAgent}`} className="nxtext_paragrph">{userAgent}</label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        <div className='nxtext_field_with_lbl'>
                                                            <div className='nxtext_h_with_tip'>
                                                                <label className='nxtext_secondary_heading'>{__('Custom Robots.txt Entries', 'nexter-extension')}</label>
                                                                <div className='nxtext_tooltip'>{tooltipSVG}
                                                                    <span className="nxtext_tooltiptext">{__('Add custom entries to robots.txt file. These will be added after the built-in AI crawler blocking rules.', 'nexter-extension')}</span>
                                                                </div>
                                                            </div>
                                                            <textarea 
                                                                id="custom_robots_txt" 
                                                                name="custom_robots_txt" 
                                                                className='nxtext_factor_auth_textarea nxtext_block_ai_crawlers_textarea' 
                                                                rows="5"
                                                                placeholder={__('User-agent: CustomBot\nDisallow: /private/', 'nexter-extension')}
                                                                onChange={(e) => {
                                                                    const updatedSettings = { ...enabledSettings };
                                                                    if (updatedSettings[field]) {
                                                                        updatedSettings[field].values.custom_robots_txt = e.target.value;
                                                                    }
                                                                    setEnabledSettings(updatedSettings);
                                                                }}
                                                                value={enabledSettings[field]?.values?.custom_robots_txt || ''}
                                                            />
                                                        </div>
                                                        <div className='nxtext_paragrph'>
                                                            {__('This section can be used to add custom entries to the robots.txt file. The built-in AI crawler blocking rules are automatically added.', 'nexter-extension')}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {field === 'limit-login-attempt' && (
                                                <>
                                                <div className='nxtext_login_attempt_inner'>
                                                    {viewLoginData === false ?
                                                        <>
                                                        <div className="nxt-number-field"><input id="text_field_2" className="nxtext_text_field" value={enabledSettings[field].values.failed_login} type="number" min={1} max={10} step={1} onChange={(e)=> {
                                                            const updatedSettings = { ...enabledSettings };
                                                            if (updatedSettings[field]) {
                                                                updatedSettings[field].values.failed_login = e.target.value;
                                                            }
                                                            setEnabledSettings(updatedSettings);
                                                        }} style={{maxWidth: '55px'}} />{__('Limit Allowed failed login attempts before a 15-minute lockout.','nexter-extension')}
                                                        </div>
                                                        <div className="nxt-number-field"><input id="text_field_3" className="nxtext_text_field" value={enabledSettings[field].values.lockout_login} type="number" min={1} max={10} step={1} onChange={(e)=> {
                                                            const updatedSettings = { ...enabledSettings };
                                                            if (updatedSettings[field]) {
                                                                updatedSettings[field].values.lockout_login = e.target.value;
                                                            }
                                                            setEnabledSettings(updatedSettings);
                                                        }} style={{maxWidth: '55px'}} />{__('After multiple lockouts, further login attempts will be blocked for 30 Minutes.','nexter-extension')}
                                                        </div>
                                                        {nxtext_ajax_object.pro && popupData.isFreemium &&
                                                        <>
                                                            <div className='nxtext_h_with_tip'>
                                                                <div className='nxtext_secondary_heading'>{__('Never Block IP Addresses', 'nexter-extension')}</div>
                                                                <div className='nxtext_tooltip'>{tooltipSVG}
                                                                    <span className="nxtext_tooltiptext">{__('Enter each IPv4 or IPv6 address on a new line.', 'nexter-extension')}</span>
                                                                </div>
                                                            </div>
                                                            <textarea id="ip_address_list" name="ip_address_list" rows="2" className='nxtext_factor_auth_textarea' placeholder={'Ex. 103.250.148.152'} onChange={(e)=> {
                                                                const updatedSettings = { ...enabledSettings };
                                                                if (updatedSettings[field]) {
                                                                    updatedSettings[field].values.ip_address_list = e.target.value;
                                                                }
                                                                setEnabledSettings(updatedSettings);
                                                            }} value={enabledSettings[field]?.values?.ip_address_list || ''} />
                                                        </>
                                                        }
                                                        <div className='nxtext_h_with_tip'>
                                                            <div className='nxtext_secondary_heading'>{__('Detect IP from Specific Header', 'nexter-extension')}</div>
                                                            <div className='nxtext_tooltip'>{tooltipSVG}
                                                                <span className="nxtext_tooltiptext">{ __('Use HTTP_X_FORWARDED_FOR IP if behind proxy; leave blank for default detection', 'nexter-extension')}</span>
                                                            </div>
                                                        </div>
                                                        <input type="text" id="header_override" name="header_override" className='nxtext_text_field'  onChange={(e)=> {
                                                            const updatedSettings = { ...enabledSettings };
                                                            if (updatedSettings[field]) {
                                                                updatedSettings[field].values.header_override = e.target.value;
                                                            }
                                                            setEnabledSettings(updatedSettings);
                                                        }} value={enabledSettings[field]?.values?.header_override || ''} />
                                                        <div className='nxtext_secondary_heading nxt-limit-list-view' onClick={() => setviewLoginData(true)}>{__('View Logs', 'nexter-extension')}</div>
                                                        </>
                                                    :
                                                        <>
                                                        {processLoginData ? (
                                                        <div className='nxtext-get-process'>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" stroke="#1717CC" viewBox="0 0 38 38">
                                                            <g fill="none" fillRule="evenodd" strokeWidth="2" transform="translate(1 1)">
                                                                <circle cx="18" cy="18" r="18" strokeOpacity=".3" />
                                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                                <animateTransform
                                                                    attributeName="transform"
                                                                    dur="1s"
                                                                    from="0 18 18"
                                                                    repeatCount="indefinite"
                                                                    to="360 18 18"
                                                                    type="rotate"
                                                                />
                                                                </path>
                                                            </g>
                                                            </svg>
                                                        </div>
                                                        ) : (
                                                        loginData.length > 0 ? (
                                                           <LoginAttemptTable data={loginData} />
                                                        )
                                                        :
                                                        (
                                                            <div className='nxtext-login-data-not-found'>{__('There is no data available to view the logs', 'nexter-extension')}</div>
                                                        )
                                                        )}
                                                        
                                                        </>
                                                    }
                                                </div>
                                                { viewLoginData &&
                                                    <div className='nxtext_secondary_heading nxt-limit-list-view' onClick={() => setviewLoginData(false)}>{__('Back', 'nexter-extension')}</div>
                                                }
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                        <div className='nxtext_popup_bottom'>
                            {popupData.doclink &&
                                <a className='nxtext_tertiary_btn' target="_blank" rel="noopener noreferrer" href={popupData.doclink}>{__('Read How it Works', 'nexter-extension')}</a>
                            }
                            <button className="nxtext_blue_common_btn" onClick={(ev)=> {(handlePopupSave(ev))}}>{__('Save', 'nexter-extension')}</button>
                        </div>
                    </div>
                </>
            }
            {isPopupProVisible &&
                <ProNotice isPopupVisible={isPopupProVisible} setIsPopupVisible={setIsPopupProVisible} />
            }
            {isPopupExtensionInstall &&
                <ExtensionInstallPopup isPopupExtensionInstall={isPopupExtensionInstall} setIsPopupExtensionInstall={setIsPopupExtensionInstall} />
            }
        </div>
    )

}

export default Security;